/**************************************************
 * Nombre:       Tarjeta_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Producto = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <img src={item?.img} width={'100%'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: 12, lineHeight: 1.1}}>{item?.nombre}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Producto    